<template>
  <a-modal
    :visible="visible"
    :maskClosable="false"
    :confirmLoading="loading"
    centered
    width="100%"
    wrapClassName="full-modal"
    @cancel="handleCancel"
    @ok="handleOK"
    title="JSON编辑器"
    okText="保存"
  >
    <JSONEdit v-model:value="json_obj"></JSONEdit>
    <template #footer v-if="onlyread">
      <div></div>
    </template>
  </a-modal>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue';
import { message } from 'ant-design-vue';

export default defineComponent({
  name: 'JSONEditModel',
  props: {
    visible: {
      type: Boolean,
      required: true,
      default: () => false,
    },
    json: {
      type: Object,
      default: () => {},
    },
    onlyread: {
      type: Boolean,
      required: true,
      default: () => false,
    },
  },
  emits: ['ok', 'cancel'],
  setup(props, { emit }) {
    const loading = ref(false);
    const json_obj: any = ref({});
    const container = ref<any>();

    json_obj.value = props.json;

    const handleCancel = () => {
      emit('cancel');
    };
    const handleOK = () => {
      emit('ok', json_obj.value);
    };

    return {
      // fullscreen
      message,
      // edit
      loading,
      json_obj,
      container,
      handleCancel,
      handleOK,
    };
  },
});
</script>

<style lang="less">
.full-modal {
  .ant-layout-header {
    background-color: #fff;
  }

  .ant-layout-sider {
    background-color: #fff;
  }

  .ant-modal {
    top: 0;
    max-width: 100%;
    margin: 0;
    padding-bottom: 0;
  }

  .ant-modal-content {
    display: flex;
    flex-direction: column;
    height: calc(100vh);
  }

  .ant-modal-body {
    flex: 1;
    padding: 0;
    overflow: hidden;
  }

  .ant-modal-footer {
    padding: 0;
  }
}
</style>
